import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { CustomerCategories } from "./CustomerCategories";
import CustomerCategoriesQueryNode from "./__generated__/CustomerCategoriesQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof CustomerCategories> = {
  root: JSResource("CustomerCategories", () =>
    import("./CustomerCategories").then((module) => module.CustomerCategories),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: CustomerCategoriesQueryNode,
          variables: {},
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
